import { useMemo } from 'react';
import { classNames } from '../../../utils/classnames';
import styles from './SSkeletonDisplayText.module.css';

export function SSkeletonDisplayText(props: SSkeletonDisplayTextProps): React.JSX.Element {
    const className = useMemo(
        () => classNames(styles.SSkeletonDisplayText, ...(props.classNames ?? [])),
        [props.classNames]
    );

    const style = useMemo(
        () =>
            ({
                '--skeleton-display-text-max-width': props.maxWidth ?? undefined,
                '--skeleton-display-text-height': props.height ?? undefined,
            }) as React.CSSProperties,
        [props.maxWidth, props.height]
    );

    return <div className={className} style={style} />;
}

export interface SSkeletonDisplayTextProps {
    /**
     * @default '28px'
     */
    height?: `${number}px`;
    /**
     * @default '120px'
     */
    maxWidth?: `${number}px` | `${number}ch` | `${number}%`;
    /**
     * Custom CSS classes to apply to the component
     */
    classNames?: string[];
}
